import { useContext } from 'react'
import { useTranslation } from 'libs/i18n'
import { format, parseISO } from 'libs/dates'
import { Currency } from 'shared/components'
import { DATE_FORMAT } from 'shared/components/Datepicker/utils/date'
import { StoreSettingsContext } from 'store/StoreSettingsContext'
import { useCouponStatusLabel } from 'features/coupons/molecules/CouponStatus/CouponStatus'
import type { CouponItem } from 'features/coupons/types/coupons.types'

export const useCouponDetails = () => {
	const { t } = useTranslation()
	const statusLabel = useCouponStatusLabel()
	const storeCtx = useContext(StoreSettingsContext)
	const currency = storeCtx?.storeSettings?.currency

	const formatDiscount = ({ price_discount }: CouponItem) => {
		const amount = Number(price_discount.value)

		if (price_discount.is_percentage) return `${amount}%`

		return currency ? <Currency price={{ amount, currency }} /> : amount
	}

	return (coupon: CouponItem) => ({
		status: statusLabel(coupon.status),
		discount: formatDiscount(coupon),
		bookingWindow: [coupon.booking_window_start, coupon.booking_window_end]
			.map((date) => format(parseISO(date), DATE_FORMAT))
			.join(' – '),
		maxUses: coupon.max_uses ?? t('Unlimited'),
		expires: coupon.valid_until ? format(parseISO(coupon.valid_until), 'yyyy-MM-dd') : '—'
	})
}
